/**
 * Created by jax.luo on 2017/6/9.
 */
angular.module('dpw.components')
    .component('dpwFloatingLayer', {
        controller: ['$element', function (element) {

            this.$onInit = function () {
                var $element = $(element);
                var originEle = element[0];
                var $document = $(document);


                setTimeout(function () {
                    $element.css({
                        "position": "fixed",
                        "bottom": 0
                    });
                    $element.addClass('dpw-floating-layer-is-floating');

                    var eleBottomToTop = originEle.getBoundingClientRect().bottom;

                    $(window).on('scroll', function () {
                        setPostion();
                    });

                    $(window).on('resize', function () {
                        eleBottomToTop = originEle.getBoundingClientRect().bottom;
                        setPostion();
                    });

                    function setPostion() {
                        if ($document.scrollTop() < $(".footer").offset().top - eleBottomToTop) {
                            $element.css("position", "fixed");
                            $element.addClass('dpw-floating-layer-is-floating');
                        }
                        else {
                            $element.css("position", "static");
                            $element.removeClass('dpw-floating-layer-is-floating');

                        }
                    }
                });

            };
        }]
    });